export default __webpack_public_path__ + "static/media/number-5.35cfe837.svg";